import {
	// SET_OPEN_ID
	SAVE_TOKEN,
	SAVE_USER,
	SAVE_USER_TIME,
	RECORD_USERINFO,
	SET_NAVMENUS,
	SAVE_TRACE,
	SET_SYS_CONFIG,
	SET_API_TOKEN,
	SET_SYS_CONFIG_TIME,

	SET_PROVINCES,
	SET_CITYS,
	SET_DISTRICTS,
	SET_TOWN,
	RECORD_GUESTINFO,
	SETPAGECACHE,
	SETPAGECONFIG,
	SETPAGECONFIGDETAIL,
	SETMAINTAIN,
	SETSERVICEURL,
	SAVEWAREHOUSE,
	SET_ORPHANSHOWTIME,
	SET_DEVICEID,
	SET_LANGUAGE,
} from './mutation-types.js'

export default {
	// [SET_OPEN_ID](state, open_id) {
	// 	state.openId = open_id;
	// },

	[SAVE_TOKEN](state,token){
		state.userToken = token;
	},
	[SAVE_USER](state, info) {
		if(info){
			state.userInfo = info.value;
			var date=new Date();
			//var expired=((info.version||{}).expired||30)
			var expired=30;
			//date.setTime(date.getTime()+1000*info.version.expired);
			date.setTime(date.getTime()+1000*expired);
			state.dateList['userInfo']=date.getTime();
		}
		else{
			state.userInfo=null;
		}
		
	},
	[SAVE_USER_TIME](state){
		state.dateList['userInfo']=null;
	},
	[RECORD_USERINFO](state, info) {	
		if(info){
			var date=new Date();
			var expired=((info.version||{}).expired||30)
			date.setTime(date.getTime()+1000*expired);
			state.dateList['wechatUserInfo']=date.getTime();
		}
		state.wechatUserInfo = info;
	},
	[RECORD_GUESTINFO](state,info){
		state.guestInfo=null
		state.guestInfo=info;
	},
	[SET_NAVMENUS](state,menus){
		state.navMenus = menus;
	},
	[SAVE_TRACE](state,code){
		if (JSON.stringify(code) == "{}") {
			state.trace = {};
		}else if (code) {
			if (!state.trace[code]) {
				state.trace[code] = 1;
			}else {
				state.trace[code] += 1;
			}
		}
		
	},
	//记录系统配置信息
	[SET_SYS_CONFIG](state, sysConfig) {
		var now_time=sysConfig.response.time
		var {config,cache_model}= sysConfig.data.value;
		config.cache_model=cache_model;
		config.now_time=now_time;
		var model=(state.sysConfig||{});
		model.value=config
		state.sysConfig = model;

		var date=new Date();
		date.setTime(date.getTime()+1000*sysConfig.data.version.expired);
		state.dateList['sysConfig']=date.getTime();
		//setStore('sysConfig', state.sysConfig);
	},
	[SET_SYS_CONFIG_TIME](state){
		state.dateList['sysConfig']=null
	},
	[SETMAINTAIN](state,data){
		state.maintain=data
	},
	[SET_PROVINCES](state,provinces){
		state.provinces = provinces;
	},
	[SET_CITYS](state,citys){
		state.citys = citys;
	},
	[SET_DISTRICTS](state,dicts){
		state.districts = dicts;
	},
	[SET_TOWN](state,data){
		if(state.town){
			state.town.value = [...state.town.value,...data.value];
		}
		else{
			state.town=data;
		}
	},
	[SETPAGECACHE](state,{pageKey,key,params,}){
		let pageCache = state.pageCache
		for (let pageKey in pageCache) {
			for (let key in pageCache[pageKey]) {
				let params = pageCache[pageKey][key]
				let date = (new Date()).valueOf()
				let expiredDate = params.createTime + params.expired * 1000
				console.log(date > expiredDate)
				if (date > expiredDate) delete pageCache[pageKey][key]
			}
		}
		let data = {
			createTime:(new Date()).valueOf(),
			expired:120,
			value:params,
		}
		if (pageCache[pageKey]) {
			pageCache[pageKey][key] = data
		} else  if (pageCache) {
			let obj = {}
			obj[key] = data
			pageCache[pageKey] = obj
		} else {
			let obj = {}
			obj[pageKey] = {}
			obj[pageKey][key] = data
			pageCache = obj
		}
		state.pageCache = pageCache
			

	},
	[SETPAGECONFIG](state,config){
		state.pageConfig=config
	},
	[SETPAGECONFIGDETAIL](state,config){
		state.pageConfigDetail=config
	},
	[SETSERVICEURL](state,value){
		state.serviceUrl = value
	},
	[SAVEWAREHOUSE](state,value){
		state.saveWarehouse=value
	},
	[SET_ORPHANSHOWTIME](state,value) {
		state.orphanShowTime = value
	},
	[SET_DEVICEID](state,value){
		state.deviceId = value
	},
	[SET_LANGUAGE](state,value){
		state.setLanguage = value
	}
}
